import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, tap, map } from 'rxjs/operators';
import { Constants } from '../constants';
import { FGAData } from '../fga/models';

@Injectable({
  providedIn: 'root'
})
export class UsersService {
  public details$ = new BehaviorSubject<FGAData>(null);
  constructor(private readonly http: HttpClient) { }

  constants: Constants = new Constants();

  HTTP_CONSTANT_OPTIONS = {
    headers: new HttpHeaders({
		'Content-Type': 'application/json, application/x-www-form-urlencoded;charset=ISO-8859-15',
		'Accept': 'application/json'
    })
  };

  getUserDetails(): Observable<any> {
    console.info("Entered getuser details");

		return this.http
      .get(this.constants.getApiBasePath() + '/api/v1/getusers', this.HTTP_CONSTANT_OPTIONS)
			.pipe(
				tap(_ => this.log('data success')),
				catchError(this.handleError<any>('data fails'))
			);
  }
 
  getUserInfo(toyotaGUID): Observable<any> {
    console.info("Entered getUserInfo");

    return this.http
      .get(this.constants.getApiBasePath() + `/api/v1/getuserinfo/${toyotaGUID}`, this.HTTP_CONSTANT_OPTIONS)
      .pipe(
        tap(_ => this.log('data success')),
        catchError(this.handleError<any>('data fails'))
      );
  }  

  getUserInfoFreeze(toyotaGUID): Promise<any> {

		return this.http
    .get(this.constants.getApiBasePath() + `/api/v1/getuserinfo/${toyotaGUID}`, this.HTTP_CONSTANT_OPTIONS)
			.pipe(map(res => res))
			.toPromise();
	}

  private handleError<T>(_operation, result?: T) {
		return (error: any): Observable<T> => {
			console.info(error); // log to console instead
			return of(result as T);
		};
  }

  getDetails(): Observable<FGAData> {
    return this.details$.asObservable();
  }

	/** Log a message */
	private log(message: string) {
		console.info('Message: ' + message);
	}
}
